<template>
  <div class="ranges">
    <ul v-if="ranges">
      <li
        v-for="(value, key) in ranges"
        @click="$emit('clickRange', value)"
        :data-range-key="key"
        :key="key"
      >{{$t(key)}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["ranges"]
};
</script>
